module.exports = __webpack_public_path__ + "img/skull.a03776f7.png";